import * as React from 'react';
import { Check } from '@wix/wix-ui-icons-common';
import s from './solution-overview.scss';
import {
  BenefitPreviewWrapper,
  fillWithPreviewBenefits,
} from '../../preview-elements/benefit-wrapper';
import { PreviewMode } from '../../preview-elements/preview-context';
import { composer } from '../../../../component-decorators/composer';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { Box, Text } from '@wix/design-system';

interface IDescriptionBenfitProps extends Partial<WithTranslationProps> {
  benefits: string[];
  appId: string;
}
export const DescriptionBenefits = composer()
  .withTranslation()
  .compose(({ benefits, appId, t }: IDescriptionBenfitProps) => {
    return (
      <PreviewMode.Consumer>
        {(value) =>
          fillWithPreviewBenefits(benefits, t, value.isPreview).map(
            ({ benefit, shouldReplace }, index) => (
              <Benefit
                benefit={benefit}
                index={index}
                shouldReplace={shouldReplace}
                appId={appId}
                key={index}
              />
            ),
          )
        }
      </PreviewMode.Consumer>
    );
  });
interface IBenefitProps {
  benefit: string;
  appId: string;
  shouldReplace: boolean;
  index: number;
}
const Benefit = ({ benefit, appId, shouldReplace, index }: IBenefitProps) => {
  return (
    <BenefitPreviewWrapper
      appId={appId}
      benefit={benefit}
      shouldReplace={shouldReplace}
      index={index}
    >
      <Box
        key={index}
        align="center"
        direction="horizontal"
        verticalAlign="top"
        marginBottom="8px"
        inline
      >
        <Check size="18" className={s.overViewCheckMark} /> &nbsp; &nbsp;{' '}
        <Text dataHook={`benefit-${index}`}>{benefit}</Text>
      </Box>
    </BenefitPreviewWrapper>
  );
};
